module.exports = __webpack_public_path__ + "img/modular02_active.5cbad231.png";